import React from "react";
import useAuth from '../hooks/useAuth';

function UserProfile() {
  const { auth } = useAuth();
  //console.log('from Login' + JSON.stringify(auth.userFromCognito, null, 2));

  return (
    <div>
      <h2>User Profile</h2>
      {auth?.token ? (
        <div>
          <p><strong>Token:</strong> {auth.accessToken}</p>
          <p><strong>User Info:</strong> {auth.userFromCognito.attributes.name}</p>
        </div>
      ) : (
        <p>No user is currently logged in.</p>
      )}
    </div>
  );
}

export default UserProfile;